export default {
  path: '/worktime',
  component: () => import(/* webpackChunkName: 'layout' */'@/views/worktime/layout/index'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      name: 'my',
      component: () => import(/* webpackChunkName: 'my' */'@/views/worktime/index')
    },
    {
      path: '/worktime/approval',
      name: 'approval',
      component: () => import(/* webpackChunkName: 'approval' */'@/views/worktime/approval')
    },
    {
      path: '/worktime/approvalTransfer',
      name: 'approvalTransfer',
      component: () => import(/* webpackChunkName: 'approvalTransfer' */'@/views/worktime/approvalTransfer')
    },
    {
      path: '/worktime/set',
      name: 'set',
      component: () => import(/* webpackChunkName: 'set' */'@/views/worktime/set')
    },
    {
      path: '/worktime/staff',
      name: 'staff',
      component: () => import(/* webpackChunkName: 'staff' */'@/views/worktime/staff')
    },
    {
      path: '/worktime/holidays',
      name: 'holidays',
      component: () => import(/* webpackChunkName: 'approvalMonthPlan' */'@/views/worktime/holidays')
    },
  ]
}